var noClickTime = new Date();
// var bLoginTime = 0;

module.exports = {
  StrToFloat(s){
    return parseFloat(s);
  },

  sGetNmRecord(zRecord, sId){
    for(var i = 0; i < zRecord.zId.length; i++){
      if (zRecord.zId[i] == sId) {
        return zRecord.zNm[i];
      }
    }
    return "";
  },

  bInCheck(zRecord, sData){
    for(var i = 0; i < zRecord.length; i++){
      if (zRecord[i] == sData) {
        return true;
      }
    }
    return false;
  },

  sGetId(s) {
    // return s.substring(0, 6);
    if (s == "") return s;
    if (s == "ALL") return s;
    if (s == "NONE") return s;

    var idx = s.indexOf("-");

    if (idx == -1) {
      return "";
    } else {
      return s.substring(0, idx);
    }
  },

  sGetNm(s) {    
    if (s == "") return s;
    var idx = s.indexOf("-");
    if (idx == -1) {
      return "";
    } else {
      return s.substring(idx+1, s.length);
    }
  },

  sBoolToStr(data) {
    if (data) {
      return "Y"
    } else {
      return "N"
    }    
  },

  sFormatDate(date) { 
    var d = new Date(date), month = '' + (d.getMonth() + 1), 
    day = '' + d.getDate(), year = d.getFullYear(); 
    if (month.length < 2) month = '0' + month; 
    if (day.length < 2) day = '0' + day; 
    return [year, month, day].join('-');
    // return [month, day, year].join('-');
  },

  pad(n, width) {
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;
  },

  sFormatFloat(num){		    
    if(num==0) return 0;

    var reg = /(^[+-]?\d+)(\d{3})/;
    var n = (num + '');
  
    while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2');  
    return n;
  }, 

  // sNowDate3(){		    
  //   var date = new Date(); 
  //   var year = date.getFullYear(); 
  //   var month = new String(date.getMonth()+1); 
  //   var day = new String(date.getDate()); 

  //   if(month.length == 1){ 
  //     month = "0" + month; 
  //   } 
  //   if(day.length == 1){ 
  //     day = "0" + day; 
  //   } 

  //   return year + "-" + month + "-" + day;
  // },  

  s10YearSel(){
    var today = new Date();
    var daysago = 365*10;
    var oldday = new Date(today-(3600000*24*daysago));
    return oldday;
  },

  sYearSel(){
    var today = new Date();
    var daysago = 365;
    var oldday = new Date(today-(3600000*24*daysago));
    return oldday;
  },
  
  sMonthSel(){
    var today = new Date();
    var daysago = 30;
    var oldday = new Date(today-(3600000*24*daysago));
    return oldday;
  },

  sTomorrowSel(){
    var today = new Date();    
    var oldday = new Date(today.setDate(today.getDate()+1));
    return oldday;
  },

  getState (cSendFlag, cCode) {      
    if (cSendFlag === "OK") return '●'
    if (cSendFlag === "OK2") return '▲'      
    if (cSendFlag === "ING") return '...'      
    else return "X(" + cCode + ")";
  },

  fStrToFloat(s) {
    if (s == "") {return 0}
    if (s == null) {return 0}

    return parseFloat(s);
  },

  clickCheckTime(){
    noClickTime = new Date();
  },

  bDbclickCheck(){
    var n = (new Date())-noClickTime;    
    return (n < 200);
  },

  getExtension(fileName) {    
    var fileLength = fileName.length;    
    
    var lastDot = fileName.lastIndexOf('.'); 
    var fileExtension = fileName.substring(lastDot+1, fileLength);     
    return fileExtension;
  },  

  checkDate(strDate){
    var chkdate=Date.parse(strDate)
    if (isNaN(chkdate)==false) {
        // var d=new Date(chkdate);
        return true;
    } else {
        return false;
    }
  },

  sGetFileType(s) {        
    if (s == "") {
      return s;
    }
    var idx = 0;
    idx = s.indexOf("video");
    if (idx > -1) { return "10-AVI";}

    idx = s.indexOf("image");
    if (idx > -1) { return "20-Image";}
    
    idx = s.indexOf("audio");
    if (idx > -1) { return "30-Music";}    

    return "00-unknown";
  },

  iDateGap(date1, date2) {      
    var dateArray1 = date1.split("-");  
    var dateArray2 = date2.split("-");  
      
    var dateObj1 = new Date(dateArray1[0], Number(dateArray1[1])-1, dateArray1[2]);  
    var dateObj2 = new Date(dateArray2[0], Number(dateArray2[1])-1, dateArray2[2]);  
      
    var betweenDay = (dateObj2.getTime() - dateObj1.getTime())/1000/60/60/24;  
      
    return(betweenDay);  
  },

  GetExcel(org, header) {    
    var ret = [];
    
    for(let i = 0; i < org.length; i++){
      var a = {}
      for(let j = 0; j < header.length; j++){
        if (header[j].text != 'Action')
          a[header[j].text] = org[i][header[j].value];
      }
      ret.push(a);
    }

    return ret;
  },
  
  getExcelFile(response, fileName) {
    let blob = new Blob(response, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });

    fileName = fileName+'.xlsx';

    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.target = '_self';
    link.download = fileName;
    link.click(); 
  },  
  
  timeForToday(value) {
    const today = new Date();
    const timeValue = new Date(value);

    const betweenTime = Math.floor((today.getTime() - timeValue.getTime()) / 1000 / 60);
    if (betweenTime < 1) return 'Just before';
    if (betweenTime < 60) {
        return `${betweenTime} minutes ago`;
    }

    const betweenTimeHour = Math.floor(betweenTime / 60);
    if (betweenTimeHour < 24) {
        return `${betweenTimeHour} hours ago`;
    }

    const betweenTimeDay = Math.floor(betweenTime / 60 / 24);
    if (betweenTimeDay < 2) {
        return `Yesterday`;
    }
    if (betweenTimeDay < 7) {
        return `${betweenTimeDay} days ago`;
    }
    return value;
    // return `${Math.floor(betweenTimeDay / 365)}년전`;
  },

  timeForTodayOnlyWith(value) {    
    if (value == null || value == "") {
      return "--";
    }
    const today = new Date();
    const timeValue = new Date(value);

    const betweenTime = Math.floor((today.getTime() - timeValue.getTime()) / 1000 / 60);
    if (betweenTime < 1) return 'Just before';
    if (betweenTime < 60) {
        return `${betweenTime} minutes ago`;
    }

    const betweenTimeHour = Math.floor(betweenTime / 60);
    if (betweenTimeHour < 24) {
        return `${betweenTimeHour} hours ago`;
    }

    const betweenTimeDay = Math.floor(betweenTime / 60 / 24);
    if (betweenTimeDay < 2) {
        return `Yesterday`;
    }
    if (betweenTimeDay < 30) {
        return `${betweenTimeDay} days ago`;
    }
    
    if (betweenTimeDay < 365) {
        const betweenTimeMonth = Math.floor(betweenTime / 60 / 24 / 30);
        return `${betweenTimeMonth} months ago`;
    }

    return `${Math.floor(betweenTimeDay / 365)} years ago`;      
  },

  ScrollDown(){
    if (window.scrollY == 0) {
      window.scrollTo(0,1);        
    }    
  },

  leadingZeros(n, digits) {
    var zero = '';
    n = n.toString();
  
    if (n.length < digits) {
      for (var i = 0; i < digits - n.length; i++)
        zero += '0';
    }
    return zero + n;
  },
  
  getNowTime() {
    var d = new Date();
    var s =
      // leadingZeros(d.getFullYear(), 4) + '-' +
      // leadingZeros(d.getMonth() + 1, 2) + '-' +
      // leadingZeros(d.getDate(), 2) + ' ' +
  
      this.leadingZeros(d.getHours(), 2) + ':' +
      this.leadingZeros(d.getMinutes(), 2);
      // leadingZeros(d.getSeconds(), 2);
  
    return s;
  },
    
  sDateTime(d) {    
    var s =

      this.leadingZeros(d.getMonth() + 1, 2) + '-' +
      this.leadingZeros(d.getDate(), 2) + '-' +
      this.leadingZeros(d.getFullYear(), 4) + ' ' +
  
      this.leadingZeros(d.getHours(), 2) + ':' +
      this.leadingZeros(d.getMinutes(), 2) + ':' +
      this.leadingZeros(d.getSeconds(), 2);
  
    return s;
  },
    
  sDate(d) {    
    var s =      
      this.leadingZeros(d.getMonth() + 1, 2) + '-' +
      this.leadingZeros(d.getDate(), 2) + '-' +
      this.leadingZeros(d.getFullYear(), 4)   
    return s;
  },
  sDateMonth(d) {    
    var s =      
      this.leadingZeros(d.getMonth() + 1, 2) + '-' +
      this.leadingZeros(d.getDate(), 2)
    return s;
  },
  

  sKorDate(d){
    var s = d.substring(6, 10) + "-" + d.substring(0, 2) + "-" + d.substring(3, 5);     
    return s;
  },

  CheckPWForm(cPwd) {
    var check1 = /^(?=.*[a-zA-Z])(?=.*[0-9]).{10,30}$/.test(cPwd);
    var check2 = /^(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{10,30}$/.test(cPwd);
    var check3 = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9]).{8,30}$/.test(cPwd);

    if(!(check1||check2||check3)){
      return false;
    }

    return true
  },
  
  CheckPWFormNew(cPwd) {
    var check1 = /^(?=.*[~!@#$%^&*|;:/?])(?=.*[a-z]).{10,30}$/.test(cPwd);
    var check2 = /^(?=.*[~!@#$%^&*|;:/?])(?=.*[A-Z]).{10,30}$/.test(cPwd);
    var check3 = /^(?=.*[~!@#$%^&*|;:/?])(?=.*[0-9]).{10,30}$/.test(cPwd);
    var check4 = /^(?=.*[a-z])(?=.*[A-Z]).{10,30}$/.test(cPwd);
    var check5 = /^(?=.*[a-z])(?=.*[0-9]).{10,30}$/.test(cPwd);
    var check6 = /^(?=.*[A-Z])(?=.*[0-9]).{10,30}$/.test(cPwd);
    var check7 = /^(?=.*[~!@#$%^&*|;:/?])(?=.*[a-z])(?=.*[A-Z]).{8,30}$/.test(cPwd);
    var check8 = /^(?=.*[~!@#$%^&*|;:/?])(?=.*[a-z])(?=.*[0-9]).{8,30}$/.test(cPwd);
    var check9 = /^(?=.*[~!@#$%^&*|;:/?])(?=.*[A-Z])(?=.*[0-9]).{8,30}$/.test(cPwd);
    var check10 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,30}$/.test(cPwd);
    var check11 = /[ㄱ-ㅎㅏ-ㅣ가-힣]/.test(cPwd);
    
    if(!(check1||check2||check3||check4||check5||check6||check7||check8||check9||check10) || check11){
      return false;
    }

    return true
  },
  
  CheckLinePhoneNum(cTel) {
    var check1 = /^02[0-9]{3,4}[0-9]{4}$/.test(cTel)
    var check2 = /^070[0-9]{3,4}[0-9]{4}$/.test(cTel)
    var check3 = /^0[3-6][0-9][0-9]{3,4}[0-9]{4}$/.test(cTel)
    var check4 = /^1[0-9]{3}[0-9]{4}$/.test(cTel)

    if(!(check1||check2||check3||check4)){
      return false;
    }

    return true
  },
  
  CheckURL(Url) {
    var check1 = /(\.\.{1,})|(\.\/{1,})|(\/\.{1,})|(\/\/{2,})/g.test(Url);
    var check2 = /^http(s?):\/\/([0-9a-zA-Z-./_^]+)([0-9a-zA-Z])$/.test(Url);

    if(!(check1||check2)){
      return false;
    }

    return true
  },
  
  CheckEmail(cEmail) {
    // var check1 = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(cEmail)
    let cCheckEmail = cEmail.replace(/(\s*)/g,'')
    if(!/^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(cCheckEmail)){
      return {bResult : false , cEmail : ""};
    }

    return {bResult : true , cEmail : cCheckEmail};
  },

  ChangeArray(zArray){
    let zEndArray = []
    for (let i =0; i < zArray.length; i ++) {
      zEndArray.push({
        id : zArray[i]
      })
    }
    return zEndArray
  },

  SetRandomCheckNum(){
    var a = ""
    for (let i = 0; i < 6; i++) {
      a += String(Math.floor(Math.random() * 10))
    }
    return a
  },

  sYearFirstDate(){	    
    var date = new Date(); 
    var year = date.getFullYear(); 
    return  new Date(year,"00","01");
  },  

  sBefore1Moth(){
    let d = new Date();
    let sel_month = -1;
    d.setMonth(d.getMonth() + sel_month );

    return d;
  },  

  sAfter1Moth(){		    
    let d = new Date();
    let sel_month = +1;
    d.setMonth(d.getMonth() + sel_month );

    return d;
  },

  sTenLenghtDate(d){
    var s = ""
    s = d.substring(0,4) + "-" + d.substring(4,6) + "-" + d.substring(6,8)
    return s
  },

  s14OldCheck(birth){
    var today = new Date();
    var yyyy = today.getFullYear();
    var mm = today.getMonth() < 9 ? "0" + (today.getMonth() + 1) : (today.getMonth() + 1); // getMonth()
    var dd  = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();

    if (parseInt(String(yyyy) + String(mm) + String(dd)) - parseInt(birth) - 140000 < 0) {
      return false
    }

    return true
  },

  ChangeNumToMin(Num) {
    let iMin = parseInt(Num/60)
    let iSec = Num -iMin*60
    if (iSec < 10) {
      return String(iMin) + " : 0" + String(iSec)
    } else {
      return String(iMin) + " : " + String(iSec)
    }
  },
  
  AddEmail1and2(Addr1,Addr2) {
    return Addr1 + "@" + Addr2
  },
  
  ChangeCorpNm(item) {
    if (item.Local == 'Y') {
      return item.CorpNmKor
    } else {
      return item.CorpNmEng
    }
  },
  
  ChangeCorpNm3Data(Local,KorNm,EngNm) {
    if (Local == 'Y') {
      return KorNm
    } else {
      return EngNm
    }
  },

  RemoveBlank(cText) {
    return cText.replace(/ /gi,"")
  },

  bCheckNotiDoTest(cTestDate) {
    var AskDoTestDate = new Date(cTestDate.substring(0,10));
    AskDoTestDate.setMonth(AskDoTestDate.getMonth() + 6)
    AskDoTestDate.setDate(AskDoTestDate.getDate() - 11)

    var now = new Date();
    now.setHours(0, 0, 0, 0)

    return AskDoTestDate <= now
  },
};
